import React, { useState } from 'react';
import './adduser.css';
import './OneToOneAdd.css';


const AddUser = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    company: '',
    occupation: '',
    number: '',
    email: '',
    password: '',
    retypePassword: '',
    role: 'member',
    date: '',
    collageName: '',
    year: '',
    hlabc: 'Member',
    universityName: 'Gujarat University',
  });

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (formData.password !== formData.retypePassword) {
      alert('Passwords do not match!');
      return;
    }

    const token = localStorage.getItem('token');
    const userId = localStorage.getItem('userId');

    if (!token || !userId) {
      alert('Authorization error. Please log in again.');
      return;
    }

    let formattedDate = '';
    if (formData.date) {
      const dateObj = new Date(formData.date);
      formattedDate = dateObj
        .toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        .replace(/ /g, '-');
    }

    const data = { ...formData, date: formattedDate };

    try {
      const apiUrl = process.env.REACT_APP_SERVER_IP + '/api/admin/adduser';
      setLoading(true);
      setErrorMessage('');

      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(data),
      });

      const result = await response.json();

      if (response.ok) {
        alert('User added successfully!');
        setFormData({
          firstName: '',
          lastName: '',
          company: '',
          occupation: '',
          number: '',
          email: '',
          password: '',
          retypePassword: '',
          role: 'member',
          date: '',
          collageName: '',
          year: '',
          hlabc: 'Member',
          universityName: 'Gujarat University',
        });
      } else {
        setErrorMessage(result.message || 'An error occurred while adding the user.');
        alert(result.message || 'An error occurred');
      }
    } catch (error) {
      console.error('Error:', error);
      setErrorMessage('An error occurred while submitting the form');
      alert('An error occurred while submitting the form');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contain">
      <main className="main-content">
        <div className="form-containerCommon">
          <h2 className="name">Add User</h2>

          <form id="useForm" onSubmit={handleSubmit}>
            {/* <div className="form-row">
              <div className="form-group">
                <input
                  type="text"
                  name="firstName"
                  placeholder="First Name"
                  value={formData.firstName}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="form-group">
                <input
                  type="text"
                  name="lastName"
                  placeholder="Last Name"
                  value={formData.lastName}
                  onChange={handleChange}
                  required
                />
              </div>
            </div> */}

            <div className="form-group full-width">
              <input
                type="text"
                name="firstName"
                placeholder="First Name"
                value={formData.firstName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <input
                type="text"
                name="lastName"
                placeholder="Last Name"
                value={formData.lastName}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <input
                type="text"
                name="company"
                placeholder="Company Name / Brand Name"
                value={formData.company}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <input
                type="text"
                name="occupation"
                placeholder="Category"
                value={formData.occupation}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <input
                type="text"
                name="number"
                placeholder="Contact Number"
                value={formData.number}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  if (value.length <= 10) {
                    setFormData({ ...formData, number: value });
                  }
                }}
                maxLength="10"
                pattern="\d{10}"
                title="Please enter exactly 10 digits"
                required
              />
            </div>

            <div className="form-group full-width">
              <input
                type="email"
                name="email"
                placeholder="Email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <input
                type="password"
                name="password"
                placeholder="Password"
                value={formData.password}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <input
                type="password"
                name="retypePassword"
                placeholder="Retype Password"
                value={formData.retypePassword}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group full-width">
              <input
                type="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                max={new Date().toISOString().split('T')[0]}
              />
            </div>

            <div className="form-group full-width">
              <input
                type="text"
                name="collageName"
                placeholder="Collage Name"
                value={formData.collageName}
                onChange={handleChange}
              />
            </div>

            <div className="form-group full-width">
              <input
                type="text"
                name="year"
                placeholder="Passing Year"
                value={formData.year}
                onChange={handleChange}
                maxLength="4"
                pattern="^\d{4}$"
                title="Please enter a 4-digit year"
              />
            </div>

            {/* Keep your radio groups and submit button as is */}



            <div className="radio-sectionn">
              <label className="section-labell">Role :-</label>
              <div className="radio-optionss">
                <label>
                  <input type="radio" name="role" value="member" checked={formData.role === 'member'} onChange={handleChange} />
                  Member
                </label>
                <label>
                  <input type="radio" name="role" value="admin" checked={formData.role === 'admin'} onChange={handleChange} />
                  Admin
                </label>
              </div>
            </div>

            <div className="radio-sectionn">
              <label className="section-labell">HLABC :-</label>
              <div className="radio-optionss">
                <label>
                  <input type="radio" name="hlabc" value="Member" checked={formData.hlabc === 'Member'} onChange={handleChange} />
                  Member
                </label>
                <label>
                  <input type="radio" name="hlabc" value="spouse" checked={formData.hlabc === 'spouse'} onChange={handleChange} />
                  Spouse
                </label>
              </div>
            </div>

            <div className="radio-sectionn">
              <label className="section-labell">University Name :-</label>
              <div className="radio-optionss">
                <label>
                  <input
                    type="radio"
                    name="universityName"
                    value="Gujarat University"
                    checked={formData.universityName === 'Gujarat University'}
                    onChange={handleChange}
                  />
                  Gujarat University
                </label>
                <label>
                  <input
                    type="radio"
                    name="universityName"
                    value="Ahmedabad University"
                    checked={formData.universityName === 'Ahmedabad University'}
                    onChange={handleChange}
                  />
                  Ahmedabad University
                </label>
              </div>
            </div>

            <button type="submit" className="btnOne" disabled={loading}>
              {loading ? 'Submitting...' : 'Add User'}
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default AddUser;